import { withInstall } from '@element-plus/utils'

import Space from './src/space'

export const ElSpace = withInstall(Space)
export default ElSpace

export * from './src/space'
export * from './src/item'
export * from './src/use-space'
